import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-custom-toggle',
  templateUrl: './custom-toggle.component.html',
  styleUrl: './custom-toggle.component.scss'
})
export class CustomToggleComponent {

  @Input() btnCaption?: string;

  @Input() customValue: boolean = false;

  @Input() myTooltip = '';

  @Output() clickMyButton = new EventEmitter();

  onClick() {
    this.clickMyButton.next(true);
  }

}
